<template>
    <div class="progressbar">
      <div class="indicator" v-bind:style="{ width : total + '%'}"></div>
   </div>
</template>

<script>
  export default {
    name: 'toggleComponent',
    mounted() {
      var _this = this
      setTimeout( function(){  _this.total = 100 }, 100);
    },
    data: function() {
      return { 
        total : 0
      }
    },  
    props: {
        steps: {
            type: Number,
            default: false
        },
        step: {
            type: Number,
            default: ""
        },
    },
    computed: {
      //indicatorWidth() {
      //  return Math.round( (100 / (this.steps -1)) * (this.step - 1) )
      //}
    },
  }
</script>

<style scoped lang="scss">
   .progressbar {
      position: relative;
      display: table;
      width: 100%;
      height: 4px;
      background-color: $color-yellow-dark;

     .indicator {
        display: block;
        height: 4px;
        background-color: $color-primary;
        transition: width;
        transition-timing-function: cubic-bezier(0,1,1,0);
        transition-duration: 3000ms;
     }
   }
</style>
